<template>
  <div class="authority-manage rhBrand-box position-header">
    <navHeader :titleList="['专业品牌']" />
    <div class="rhBrand-content common-padding">
      <el-card class="box-card">
        <el-row>
          <el-col :span="5">
            <span class="search-text">品牌名：</span>
            <el-input class="search-item" placeholder="请输入" v-model="name" size="small"></el-input>
          </el-col>
          <el-col :span="5">
            <span class="search-text">英文名：</span>
            <el-input class="search-item" placeholder="请输入" v-model="englishName" size="small"></el-input>
          </el-col>
          <el-col :span="5">
            <span class="search-text">归属：</span>
            <el-select v-model="owner" placeholder="请选择" class="search-item" size="small">
              <el-option v-for="item in owners" :key="item.label" :label="item.label" :value="item.label">
              </el-option>
            </el-select>
          </el-col>
          <el-col :span="5">
            <span class="search-text">状态：</span>
            <el-select v-model="status" placeholder="请选择" class="search-item" size="small">
              <el-option v-for="item in statuses" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </el-col>
          <el-col :span="4">
            <el-button class="btn-search" round icon="el-icon-search" @click="getPageList" size="small">搜索</el-button>
            <el-button type="warning" round icon="el-icon-refresh" @click="reset" size="small">重置</el-button>
          </el-col>
        </el-row>
      </el-card>
      <el-card class="box-card flex-1 table-card">
        <el-row>
          <el-col :span="12">
            <el-button class="btns-add" icon="el-icon-plus" size="small" v-if="hasPerm('add-btns')"
              @click="add">添加</el-button>
            <!-- <el-button
              :disabled="selectData.length !== 1"
              class="btn-edit"
              icon="el-icon-edit-outline"
              size="small"
              @click="edit()"
              >修改</el-button
            > -->
            <el-button :disabled="selectData.length === 0" type="danger" icon="el-icon-delete" size="small"
              @click="deleteMore">批量删除</el-button>
            <!-- <el-button
              :disabled="selectData.length === 0"
              type="warning"
              icon="el-icon-sell"
              size="small"
              @click="exportAll"
              >全部导出</el-button
            > -->
            <el-button :disabled="selectData.length === 0" type="primary" icon="el-icon-edit-outlin" size="small"
              @click="verifyMore" v-if="hasPerm('verify-btns')">批量审核</el-button>
          </el-col>
        </el-row>
        <el-row class="common-margin flex-1 table-main">
          <el-table :data="tableData" border style="width: 100%" class="flex-1" stripe height="100%"
            @selection-change="selectRow">
            <el-table-column type="selection" width="60px" fixed align="center"> </el-table-column>
            <el-table-column prop="name" align="center" show-overflow-tooltip label="品牌名" width="160">
            </el-table-column>
            <el-table-column prop="logo" align="center" label="图标" width="160">
              <template slot-scope="scope">
                <el-image v-if="scope.row.logo" style="width: auto; height: 60px" :src="scope.row.logoSrc"
                  :preview-src-list="scope.row.logoList" fit="contain"></el-image>
              </template>
            </el-table-column>
            <el-table-column prop="englishName" align="center" show-overflow-tooltip label="英文名" width="160">
            </el-table-column>
            <el-table-column prop="one" align="center" show-overflow-tooltip label="一级品类" width="160">
              <template slot-scope="scope">
                <div class="ellipsis">{{ oneName(scope.row.one) }}</div>
              </template>
            </el-table-column>
            <el-table-column prop="origin" align="center" show-overflow-tooltip label="原产地" width="160">
              <template slot-scope="scope">
                <div class="ellipsis">{{ areaName(scope.row.origin) }}</div>
              </template>
            </el-table-column>
            <el-table-column prop="owner" align="center" show-overflow-tooltip label="归属" width="160">
            </el-table-column>
            <el-table-column prop="tradeProperty" align="center" show-overflow-tooltip label="贸易属性" width="160">
            </el-table-column>
            <el-table-column prop="status" width="180" align="center" show-overflow-tooltip label="状态">
              <template slot-scope="scope">
                <span v-if="scope.row.status === '2'">通过</span>
                <span v-else-if="scope.row.status === '3'" class="reject-btns"
                  @click="checkRejectReason(scope.row.reason)">查看驳回原因</span>
                <span v-else>待审核</span>
              </template>
            </el-table-column>
            <el-table-column prop="clientTime" width="180" label="操作时间" align="center" sortable></el-table-column>
            <el-table-column prop="fullName" align="center" show-overflow-tooltip label="展商名称" width="160">
            </el-table-column>
            <el-table-column align="center" width="400" label="操作" fixed="right">
              <template slot-scope="scope">
                <div class="btn-box">
                  <el-button v-if="scope.row.status === '2'" icon="el-icon-thumb" type="text"
                    @click="getCord(scope.row.id, scope.row.name)" size="small">获取二维码</el-button>
                  <el-button icon="el-icon-edit" type="text" @click="edit(scope.row.id)" size="small">编辑</el-button>
                  <el-button icon="el-icon-document-checked" type="text"
                    @click="verify(scope.row.id, scope.row.status, scope.row.reason)" size="small"
                    v-if="hasPerm('verify-btns')">审核</el-button>
                  <el-button icon="el-icon-document-checked" type="text" @click="addProduct(scope.row.id)"
                    size="small">添加产品</el-button>
                  <el-button icon="el-icon-delete" type="text" @click="deleteInfo(scope.row.id)"
                    size="small">删除</el-button>
                  <el-button icon="el-icon-warning-outline" type="text"
                    @click="upAndDown(scope.row.id, scope.row.shelfStatus)" size="small">{{ scope.row.shelfStatus === '1'
                        ? '下架' : '上架'
                    }}</el-button>
                  <el-button icon="el-icon-document-checked" type="text" @click="onlinePreview(scope.row.id)"
                    size="small">网页预览</el-button>
                  <!-- <el-button
                    icon="el-icon-document-checked"
                    type="primary"
                    @click="qrPreview"
                    size="small"
                    >二维码预览</el-button
                  > -->
                </div>
              </template>
            </el-table-column>
          </el-table>
          <el-pagination @current-change="handleCurrentChange" @size-change="handleSizeChange"
            :current-page.sync="currentPage" :page-size="pageSize" layout="total, prev, pager, next, sizes"
            :total="total">
          </el-pagination>
        </el-row>
      </el-card>
    </div>
    <el-dialog title="审核" width="30%" :visible.sync="dialogShow" :close-on-click-modal="false" :show-close="false"
      @close="cancel">
      <el-form :model="verifyForm" :rules="verifyRules" ref="verifyForm" label-width="100px">
        <el-form-item label="审核" prop="status">
          <el-radio-group v-model="verifyForm.status" @change="verifySelect">
            <el-radio :label="'2'">审核通过</el-radio>
            <el-radio :label="'3'">审核驳回</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="原因" v-if="verifyForm.status === '3'" prop="reason">
          <!--          <el-input type="textarea" v-model="verifyForm.statusRemarks" :rows="5"></el-input>-->
          <div style="display: flex; flex-direction: column">
            <el-checkbox-group v-model="checkList" @change="checkChange">
              <el-checkbox label="系统判定为广告信息" name="type"></el-checkbox>
              <el-checkbox label="需求信息不明确" name="type"></el-checkbox>
              <el-checkbox label="公司信息不完整" name="type"></el-checkbox>
              <el-checkbox label="公司信息无法认证" name="type"></el-checkbox>
            </el-checkbox-group>
            <el-input type="textarea" :rows="4" placeholder="请输入原因" v-model="verifyForm.reason">
            </el-input>
          </div>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="cancel">取 消</el-button>
        <el-button type="primary" @click="confirm">确 定</el-button>
      </div>
    </el-dialog>
    <transition name="phone">
      <div class="phone-box" v-if="onlineShow" @click="onlineShow = false">
        <!-- <transition name="phone"> -->
        <iphoneX v-model="onlineShow" :src="onlineUrl" />
      </div>
    </transition>
  </div>
</template>

<script>
import navHeader from '../../components/navHeader.vue'
import verifyDialog from '../../components/verifyDialog.vue'
import previewDialog from '../../components/previewDialog.vue'
import iphoneX from '../../components/iphonex.vue'

export default {
  data () {
    return {
      onlineUrl: '',
      id: '',
      isShow: false,
      name: '',
      englishName: '',
      owner: '',
      owners: [
        {
          label: '自有品牌'
        },
        {
          label: '代理品牌'
        }
      ],
      status: '',
      statuses: [
        {
          label: '待审核',
          value: '1'
        },
        {
          label: '通过',
          value: '2'
        },
        {
          label: '驳回',
          value: '3'
        }
      ],
      selectData: [],
      tableData: [],
      tableHeight: 0,
      dialogShow: false,
      verifySrc: '',
      verifyStatus: '',
      reason: '',
      previewShow: false,
      onlineShow: false,
      verifyForm: {
        status: '1',
        reason: ''
      },
      verifyRules: {
        status: [
          {
            required: true
          }
        ],
        reason: [
          {
            required: true, message: '请填写理由', trigger: 'blur'
          }
        ]
      },
      checkList: [],
      brandCategoryList: [],
      originOptions: [],
      currentPage: 1,
      pageSize: 10,
      total: 1
    }
  },
  components: {
    navHeader,
    verifyDialog,
    previewDialog,
    iphoneX
  },
  beforeRouteLeave (to, from, next) {
    if (to.name === 'MajorDetail') {
      sessionStorage.setItem('currentPage', this.currentPage)
      sessionStorage.setItem('pageSize', this.pageSize)
      sessionStorage.setItem('chineseName', this.name)
      sessionStorage.setItem('englishName', this.englishName)
      sessionStorage.setItem('owner', this.owner)
      sessionStorage.setItem('status', this.status)
    } else {
      sessionStorage.removeItem('currentPage')
      sessionStorage.removeItem('pageSize')
      sessionStorage.removeItem('chineseName')
      sessionStorage.removeItem('englishName')
      sessionStorage.removeItem('owner')
      sessionStorage.removeItem('status')
    }
    next()
  },
  created () {
    this.tableHeight = document.documentElement.clientHeight - 380
    if (sessionStorage.getItem('currentPage')) this.currentPage = Number(sessionStorage.getItem('currentPage'))
    if (sessionStorage.getItem('pageSize')) this.pageSize = Number(sessionStorage.getItem('pageSize'))
    if (sessionStorage.getItem('chineseName')) this.name = sessionStorage.getItem('chineseName')
    if (sessionStorage.getItem('englishName')) this.englishName = sessionStorage.getItem('englishName')
    if (sessionStorage.getItem('owner')) this.owner = sessionStorage.getItem('owner')
    if (sessionStorage.getItem('status')) this.status = sessionStorage.getItem('status')
    this.getPageList()
    this.getBrandCategoryList()
    this.getProducingAreaList()
  },
  mounted () { },
  methods: {
    async getPageList () {
      let params = {
        currentPage: this.currentPage,
        pageSize: this.pageSize,
        name: this.name,
        englishName: this.englishName,
        status: this.status,
        owner: this.owner
      }
      let { data: res } = await this.$http.post('/ProfessionalBrand/professionalBrand/pageList', params)
      console.log(res)
      if (res.code === '200') {
        this.tableData = res.data.records
        this.tableData.forEach((item) => {
          if (item.logo) {
            item.logoList = item.logo.split(',')
            item.logoSrc = item.logo.split(',')[0]
          } else {
            item.logoSrc = ''
            item.logoList = []
          }
        })
        this.total = parseInt(res.data.total)
      } else {
        this.$message.error(res.msg)
      }
    },
    reset () {
      this.name = ''
      this.englishName = ''
      this.status = ''
      this.owner = ''
      this.getPageList()
    },
    getBrandCategoryList () {
      this.$http.get('/ProfessionalBrand/professionalBrand/getBrandCategoryList').then(res => {
        if (res.data.code === '200') {
          this.brandCategoryList = res.data.data
        }
      })
    },
    getProducingAreaList () {
      this.$http.get('/professionalProduct/professionalProduct/getProducingAreaList').then(res => {
        console.log(res)
        if (res.data.code === '200') {
          this.originOptions = res.data.data
        }
      })
    },
    oneName (str) {
      let name = []
      let label = str ? str.split(',') : []
      this.brandCategoryList.forEach(item => {
        label.forEach(i => {
          if (i === item.id) {
            name.push(item.name)
          }
        })
      })
      return name.join(',')
    },
    areaName (str) {
      let name = []
      let label = str ? str.split(',') : []
      this.originOptions.forEach(item => {
        if (item.id === label[0]) {
          name.push(item.name)
          item.children.forEach(i => {
            if (i.id === label[1]) {
              name.push(i.name)
            }
          })
        }
      })
      return name.join('/')
    },
    // checkbox改变
    checkChange (val) {
      let reason = val.join(',')
      this.verifyForm.reason = reason
    },
    verifySelect () {
      this.verifyForm.reason = ''
    },
    selectRow (selection) {
      this.selectData = selection
    },
    // 分页
    handleCurrentChange (page) {
      this.currentPage = page
      this.getPageList()
    },
    handleSizeChange (size) {
      this.pageSize = size
      this.getPageList()
    },
    add () {
      this.$router.push('/majorDetail')
    },
    edit (id) {
      console.log(id)
      this.$router.push({
        name: 'MajorDetail',
        params: {
          id,
          type: 'edit'
        }
      })
    },
    deleteMore () {
      let ids = this.selectData.map((item) => { return item.id }).join(',')
      this.$confirm(`确认删除选中的${this.selectData.length}条数据?`, '删除提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        closeOnClickModal: false,
        showClose: false
      })
        .then(() => {
          this.$http
            .post('/ProfessionalBrand/professionalBrand/batchDelete', { ids })
            .then((res) => {
              if (res.data.code === '200') {
                this.$message.success('删除成功!')
                this.getPageList()
              } else {
                this.$message.error(res.data.msg)
              }
            })
            .catch(() => {
              this.$message({
                type: 'error',
                message: '删除失败'
              })
            })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          })
        })
    },
    exportAll () {
      this.$confirm(`确认导出选中的${this.selectData.length}条数据?`, '导出提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        closeOnClickModal: false,
        showClose: false
      })
        .then(() => {
          this.$message({
            type: 'success',
            message: '导出成功!'
          })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消导出'
          })
        })
    },
    verifyMore () {
      this.checkList = []
      this.dialogShow = true
      let list = this.selectData.map(item => item.id)
      this.id = list.join(',')
    },
    verify (id, status, reason) {
      this.checkList = []
      this.dialogShow = true
      this.id = id
      this.verifyForm.status = status
      this.verifyForm.reason = reason
    },
    confirm () {
      this.$refs.verifyForm.validate(val => {
        if (val) {
          if (this.verifyForm.status !== '3') {
            this.verifyForm.reason = ''
          }
          let params = JSON.parse(JSON.stringify(this.verifyForm))
          params.ids = this.id
          this.$http.post('/ProfessionalBrand/professionalBrand/audit', params).then(res => {
            if (res.data.code === '200') {
              this.dialogShow = false
              this.getPageList()
              this.$message.success(res.data.msg)
            }
          })
        }
      })
    },
    cancel () {
      this.dialogShow = false
      this.verifyForm = {
        status: '',
        reason: ''
      }
    },
    checkRejectReason (reason) {
      this.$alert(reason, '驳回原因', {
        confirmButtonText: '确定'
      })
    },
    getCord (id, name) {
      this.$http.get('/wechatQRCode/getWechatQRCode/3/' + id, { responseType: 'blob' }).then(res => {
        console.log(res)
        const url = window.URL.createObjectURL(new Blob([res.data], { type: 'application/x-msdownload' }))
        const link = document.createElement('a')
        link.style.display = 'none'
        link.href = url
        link.download = name + '二维码.png'
        document.body.appendChild(link)
        link.click()
        window.URL.revokeObjectURL(link.href)
        document.body.removeChild(link)
      })
    },
    addProduct (id) {
      this.$router.push({
        name: 'AddMajor',
        params: {
          id
        }
      })
    },
    deleteInfo (id) {
      this.$confirm('删除该品牌，旗下的的产品也会删除, 是否继续?', '删除提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        closeOnClickModal: false,
        showClose: false
      }).then(() => {
        this.$http.post('/ProfessionalBrand/professionalBrand/delete', { id }).then(res => {
          if (res.data.code === '200') {
            this.$message.success(res.data.msg)
            this.getPageList()
          } else {
            this.$message.error(res.data.msg)
          }
        }).catch(() => {
          this.$message({
            type: 'error',
            message: '删除失败'
          })
        })
      })
    },
    upAndDown (id, shelfStatus) {
      let tip = ''
      let status = ''
      if (!shelfStatus || shelfStatus === '2') {
        tip = '确定上架该品牌?'
        status = '1'
      } else {
        tip = '下架该品牌，会下架旗下所有的产品, 是否继续?'
        status = '2'
      }
      this.$confirm(tip, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        closeOnClickModal: false,
        showClose: false
      }).then(() => {
        this.$http
          .post('/ProfessionalBrand/professionalBrand/modifyShelfStatus', { id, shelfStatus: status })
          .then((res) => {
            if (res.data.code === '200') {
              this.$message.success(res.data.msg)
              this.getPageList()
            } else {
              this.$message.error(res.data.msg)
            }
          })
          .catch(() => {
          })
      })
    },
    onlinePreview (id) {
      this.onlineUrl = `/pages/Brand_details/Brand_details?id=${id}&type=2`
      this.onlineShow = true
    },
    qrPreview () {
      this.previewShow = true
    }
  }
}
</script>

<style lang="less">
.phone-enter,
.phone-leave-to {
  margin-top: -10%;
  opacity: 0;
  // transition: all 1s linear;
}

.phone-leave,
.phone-enter-to {
  // margin-top: -10%;
  opacity: 1;
  transition: all .5s linear;
}

.rhBrand-box {
  position: relative;

  .phone-box {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(79, 77, 77, .5);
    z-index: 99999;
    // transform: translateX(-50%);
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/majorBrand/index.vue